<template>
  <div
    class="flex h-full max-h-full flex-col gap-2 rounded-lg bg-white dark:bg-slate-700"
  >
    <div class="box relative mx-5 flex h-full min-h-0 flex-col">
      <slot name="before_header" />
      <div
        v-if="hasHeader"
        class="sticky top-0 right-0 left-0 z-10 flex justify-between gap-3 border-b bg-white/90 py-3 dark:bg-slate-700/90"
      >
        <div class="flex min-w-0 items-center gap-x-3">
          <FontAwesomeIcon v-if="icon" :icon="['fal', icon]" size="xl" />
          <h2 v-if="title" class="truncate text-2xl font-bold capitalize-first">
            {{ title }}
          </h2>
          <slot name="title" />
        </div>
        <div class="flex shrink-0 items-center gap-x-3" :class="ctaClass">
          <slot name="cta" />
        </div>
      </div>
      <div
        class="min-h-0 flex-1 bg-white py-3 dark:bg-slate-700"
        :class="
          bodyScroll ? 'overflow-y-auto' : 'flex flex-col overflow-hidden'
        "
      >
        <div v-if="bodyScroll" class="grid gap-5" :class="`grid-cols-${cols}`">
          <slot name="body" />
          <slot />
        </div>
        <template v-else>
          <slot name="body" />
          <slot />
        </template>
      </div>
      <div
        v-if="$slots.bottom"
        class="sticky right-0 bottom-0 left-0 z-10 flex justify-end gap-x-3 border-t bg-white/90 p-3 dark:bg-slate-700/90"
      >
        <slot name="bottom" />
      </div>
    </div>
  </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

/**
 * Full page frame, as Funeral Manager's BaseFixedBarCard in its white page
 * wrapper: a box with
 * a sticky title bar (`title`/`icon` props or `title` slot, `cta` slot), a
 * scrollable body and an optional sticky `bottom` bar. The body keeps the
 * 12-column grid the former BasePageFull gave its `body` slot.
 */
export default {
  name: 'BasePageFull',
  components: { FontAwesomeIcon },
  props: {
    title: { type: String, required: false, default: null },
    icon: { type: String, required: false, default: null },
    ctaClass: { type: String, required: false, default: '' },
    cols: { type: Number, required: false, default: 12 },
    /**
     * false: the body does not scroll and lays its content out as a column,
     * so a child (a table) can take the remaining height and scroll itself.
     */
    bodyScroll: { type: Boolean, required: false, default: true }
  },
  computed: {
    hasHeader() {
      return !!(this.title || this.icon || this.$slots.title || this.$slots.cta)
    }
  }
}
</script>
